module.exports = __webpack_public_path__ + "static/img/manual-22.254d188.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-22.png
// module id = N3by
// module chunks = 4